import { NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { APP_PROVIDERS } from './app.provider';
import { AuthenticationAbortedComponent } from './components/authentication-aborted/authentication-aborted.component';
import { AuthenticationLandingComponent } from './components/authentication-landing/authentication-landing.component';
import { SharedModule } from './shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Interceptor } from 'src/interceptors/app.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    AuthenticationAbortedComponent,
    AuthenticationLandingComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    APP_PROVIDERS,
    // Angular 20 需要显式提供 HttpClient — ng-upgrade-api 中的 ApiModule 虽然导入了
    // HttpClientModule，但其 Angular 14 编译格式在 Angular 20 中无法正确注册 providers，
    // 导致 NG0201: No provider for HttpClient 白屏错误。
    // withInterceptorsFromDi() 确保 HTTP_INTERCEPTORS 拦截器仍然生效。
    provideHttpClient(withInterceptorsFromDi()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
